import { ProductTypeEnum } from "@/types/ProductType";

export const PRODUCT_EDIT_TABS = [
  "product",
  "meeting",
  "access",
  "shop",
  "recordings",
  "track",
  "gating",
  "flow",
  "shopify",
  "kunaki",
] as const;

export type ProductEditTab = (typeof PRODUCT_EDIT_TABS)[number];

export function isProductEditTab(value: string | undefined): value is ProductEditTab {
  return PRODUCT_EDIT_TABS.includes(value as ProductEditTab);
}

export function productEditTabPath({
  productId,
  tab,
}: {
  productId: string;
  tab: ProductEditTab;
}): string {
  return `/products/${productId}/${tab}`;
}

export function getAvailableProductEditTabs({
  productType,
  hasShopify,
  hasKunaki,
}: {
  productType?: string;
  hasShopify: boolean;
  hasKunaki: boolean;
}): ProductEditTab[] {
  const tabs: ProductEditTab[] = ["product"];

  if (productType === ProductTypeEnum.MEETING) {
    tabs.push("meeting", "access", "shop", "recordings", "flow");
  }

  if (productType === ProductTypeEnum.TRACK) {
    tabs.push("track", "gating", "flow");
  }

  if (hasShopify) {
    tabs.push("shopify");
  }

  if (hasKunaki) {
    tabs.push("kunaki");
  }

  return tabs;
}
